import { jwtDecode } from "jwt-decode";

/**
 * Decodifica o token JWT armazenado no localStorage.
 */
export function decodeJWT() {
  if (typeof window === "undefined") return null;

  const token = localStorage.getItem("token");
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    return decoded || null;
  } catch (error) {
    console.error("Erro ao decodificar token:", error);
    return null;
  }
}
